import no from "@vee-validate/i18n/dist/locale/nb_NO.json";

const validations = {
  ...no.messages,
  finance_account: "{field} må være mellom 4 og 5 siffer",
  required_if_any: "{field} er obligatorisk",
  decimal: "{field}-feltet kan ikke ha desimaler" +
  " | {field}-feltet kan kun inneholde tall med opptil 0:{decimals} desimal" +
  " | {field}-feltet kan kun inneholde tall med opptil 0:{decimals} desimaler",
  max_value_tax_msg: "{field} kan ikke være over trekkfri sats: {formatted_max}",
  integer: "{field}-feltet kan kun inneholde heltall",
  name_list: "Hver {field} må inneholde minst 0:{min_word_count} ord med minst 1:{min_word_length} tegn",
  max_list_items: "{field} kan ikke inneholde mer enn 0:{max_count} elementer",
  max_list_item_length: "Hver {field} kan maks være 0:{max_length} tegn",
  max: "{field}-feltet kan ikke inneholde mer enn 0:{length} tegn",
  min: "{field}-feltet må inneholde minst 0:{length} tegn",
  length: "{field}-feltet må inneholde 0:{length} tegn",
  account_number: "Ugyldig kontonummer",
  attachmentRequiredForType: "Minst ett vedlegg er påkrevd for valgt type",
  numeric: "{field}-feltet kan kun inneholde siffer",
  isActiveRequiredWhenChildUsesAccount: "{field} er obligatorisk når underliggende gruppe bruker klubbens konto",
  is_not: "{field} kan ikke være denne verdien",
  date: "{field} er ikke en gyldig dato",
  time: "{field} er ikke ett gyldig klokkeslett"
};

export default validations;
